import { useEffect, useState } from "react";
import api from "../../lib/api";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [selected, setSelected] = useState(null);

  const reload = () => api.get(`/admin/customers${q ? `?q=${encodeURIComponent(q)}` : ""}`).then(r => setList(r.data));
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, []);

  const open = async (c) => {
    const r = await api.get(`/admin/customers/${c.id}`);
    setSelected(r.data);
  };
  const saveNotes = async (notes) => {
    await api.patch(`/admin/customers/${selected.customer.id}`, { notes });
    setSelected({ ...selected, customer: { ...selected.customer, notes } });
    reload();
  };

  return (
    <div className="p-10 md:p-12" data-testid="admin-customers">
      <p className="label-eyebrow text-ms-stone">CRM</p>
      <h1 className="serif text-4xl text-ms-earth mt-2">Customers</h1>

      <div className="mt-6 relative max-w-md">
        <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-ms-stone" size={16} />
        <input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>{if (e.key==='Enter') reload();}}
          placeholder="Search name or email…" className="w-full pl-10 pr-3 py-2.5 border border-ms-edge rounded-md text-sm" data-testid="customers-search" />
      </div>

      <div className="mt-6 bg-white border border-ms-edge rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-ms-cream border-b border-ms-edge">
            <tr><th className="text-left p-4 label-eyebrow text-xs">Name</th><th className="text-left p-4 label-eyebrow text-xs">Email</th><th className="text-left p-4 label-eyebrow text-xs">Bookings</th><th className="text-left p-4 label-eyebrow text-xs">Spent</th><th className="text-left p-4 label-eyebrow text-xs">Marketing</th><th className="text-left p-4 label-eyebrow text-xs">Last booking</th></tr>
          </thead>
          <tbody>
            {list.map(c => (
              <tr key={c.id} className="border-b border-ms-edge last:border-0 hover:bg-ms-cream/40 cursor-pointer" onClick={() => open(c)} data-testid={`customer-row-${c.id}`}>
                <td className="p-4 text-ms-earth">{c.name}</td>
                <td className="p-4 text-ms-stone">{c.email}</td>
                <td className="p-4 text-ms-earth">{c.total_bookings}</td>
                <td className="p-4 text-ms-earth">${c.total_spent.toFixed(2)}</td>
                <td className="p-4">{c.marketing_opt_in ? <span className="text-ms-success text-xs">Opted in</span> : <span className="text-ms-stone text-xs">—</span>}</td>
                <td className="p-4 text-ms-stone">{c.last_booking_at ? new Date(c.last_booking_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-ms-stone">No customers yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {selected && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-6" onClick={() => setSelected(null)}>
          <div onClick={e=>e.stopPropagation()} className="bg-white rounded-2xl p-8 w-full max-w-2xl space-y-5 max-h-[90vh] overflow-y-auto">
            <h2 className="serif text-2xl text-ms-earth">{selected.customer.name}</h2>
            <p className="text-ms-stone text-sm">{selected.customer.email} · {selected.customer.phone}</p>
            <div className="grid grid-cols-3 gap-4">
              <Stat k="Bookings" v={selected.customer.total_bookings} />
              <Stat k="Guests served" v={selected.customer.total_guests} />
              <Stat k="Lifetime value" v={`$${selected.customer.total_spent.toFixed(2)}`} />
            </div>
            <label className="block">
              <span className="label-eyebrow text-ms-stone text-xs">Notes</span>
              <textarea rows={3} defaultValue={selected.customer.notes} onBlur={e=>saveNotes(e.target.value)} className="mt-2 w-full border border-ms-edge rounded-md px-3 py-2.5 text-sm" data-testid="customer-notes" />
            </label>
            <div>
              <p className="label-eyebrow text-ms-stone text-xs mb-2">Booking history</p>
              <div className="divide-y divide-ms-edge">
                {selected.bookings.map(b => (
                  <div key={b.id} className="py-2 flex justify-between text-sm">
                    <span className="text-ms-earth">{new Date(b.created_at).toLocaleDateString()} · {b.guest_count} guests</span>
                    <span className="text-ms-stone">${b.total_amount} · {b.status}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Stat({ k, v }) { return <div className="border border-ms-edge rounded-lg p-4"><p className="label-eyebrow text-ms-stone text-xs">{k}</p><p className="serif text-2xl text-ms-earth mt-1">{v}</p></div>; }
